var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrooves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 236,
    viewBox: "0 0 290 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4165_70394",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 290,
    height: 236
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 290,
    height: 236,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4165_70394)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.27 218.614L232.772 208.599L227.916 218.279L190.414 228.295L195.27 218.614Z",
    fill: "#EF0808"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.158 198.848L288.181 182.017L280.019 198.285L216.996 215.116L225.158 198.848Z",
    fill: "#E3E5F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.008 143.368L436.999 103.311L432.98 111.323L282.988 151.377L287.008 143.368Z",
    fill: "#051371"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.167 146.739L219.757 135.632L214.371 146.368L172.781 157.476L178.167 146.739Z",
    fill: "#C3C6E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.139 232.982L342.662 204L339.754 209.796L231.23 238.779L234.139 232.982Z",
    fill: "#051371"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8733 249.475L90.0085 230.747L80.9259 248.85L10.793 267.58L19.8733 249.475Z",
    fill: "#051371"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7573 195.412L252.564 154.604L242.669 174.326L89.8633 215.134L99.7573 195.412Z",
    fill: "#EF0808"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.397 109.293L310.274 84.7578L298.376 108.473L206.5 133.008L218.397 109.293Z",
    fill: "#051371"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.902 112.559L347.923 92.2563L344.365 99.3482L268.344 119.651L271.902 112.559Z",
    fill: "#E3E5F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.418 176.827L279.986 157.714L278.067 161.537L206.5 180.65L208.418 176.827Z",
    fill: "#051371"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0326 200.177L110.6 181.064L108.682 184.887L37.1133 203.999L39.0326 200.177Z",
    fill: "#C3C6E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrooves);
export default __webpack_public_path__ + "static/media/grooves.1f5cf8fe08cb73584c9757f1d81a4fce.svg";
export { ForwardRef as ReactComponent };